<template>
    <div>
        <edit-button
            :tooltip="
                canCancel
                    ? $t('labels.cancel_order')
                    : $t('labels.not_cancelable_order')
            "
            icon="cancel"
            :disabled="!canCancel"
            @execute="openConfirm = true"
        ></edit-button>
        <strong-confirm-modal
            v-model="openConfirm"
            @onApprove="cancelOrder"
            @onCancel="closeModal"
        >
        </strong-confirm-modal>
    </div>
</template>
<script>
import EditButton from '@/components/table/buttons/EditButton.vue'
import StrongConfirmModal from '@/components/confirm/StrongConfirmModal.vue'
import OrdersApiClient from '@/api/RestApi/OrdersApiClient'
import Notification from '@/services/Notification/Notification'

export default {
    components: { StrongConfirmModal, EditButton },
    props: {
        item: {
            type: Object,
        },
    },
    data() {
        return {
            openConfirm: false,
        }
    },
    computed: {
        canCancel() {
            if (
                ['approved', 'cancelled', 'cancelled-after-approval'].indexOf(
                    this.item.status
                ) > -1
            ) {
                return false
            }

            return this.$date().isBefore(this.$date(this.item.cancelableUntil))
        },
    },
    methods: {
        cancelSucceed() {
            Notification.success(
                this.item.identifier,
                this.$t('notifications.entity_deleted.message', {
                    name: this.item.identifier,
                })
            )
        },
        cancelFailed(reason) {
            if (reason.response?.data?.error) {
                Notification.requestError(reason.response.data.error)
            }
        },
        cancelOrder() {
            OrdersApiClient.cancel(this.item.id, {
                reasonType: 'company_cancelled',
                refundReason: 'company_cancelled',
                refundOnBehalf: 'ordit',
            })
                .then(this.cancelSucceed)
                .catch(this.cancelFailed)
                .finally(() => {
                    this.processing = false
                })
        },
        closeModal() {
            this.openConfirm = false
        },
    },
}
</script>
